var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFlmStandard = function SvgFlmStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23a2.991 2.991 0 00-2.816 2H16a2 2 0 010-4h1.184a2.983 2.983 0 005.633 0H24a4 4 0 000-8h-7.184a3 3 0 100 2H24a2 2 0 010 4h-1.184a2.983 2.983 0 00-5.632 0H16a4 4 0 000 8h7.184A2.995 2.995 0 1026 23zm-12-8a1 1 0 111-1 1.001 1.001 0 01-1 1zm6 4a1 1 0 11-1 1 1.001 1.001 0 011-1zm6 8a1 1 0 111-1 1.001 1.001 0 01-1 1z",
    fill: "#fabc3c"
  })));
};
export default SvgFlmStandard;